import LiquidationTab from "../../Liquidation/LiquidationTab";
import IndividualLiquidationTab from "../../IndividualLiquidation/IndividualLiquidationTab";
import GlassCard from "./GlassCard";

export default function TabLiquidacion({ legalFile, onActiveChange, onCountChange, onRefresh }) {
  const isExternal = legalFile?.type === "external";

  return (
    <GlassCard>
      {isExternal ? (
        <IndividualLiquidationTab
          legalFile={legalFile}
          onActiveChange={onActiveChange}
          onCountChange={onCountChange}
          onRefreshLegalFile={onRefresh}
        />
      ) : (
        <LiquidationTab
          legalFile={legalFile}
          onActiveChange={onActiveChange}
          onCountChange={onCountChange}
          onRefreshLegalFile={onRefresh}
        />
      )}
    </GlassCard>
  );
}
